import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcc69b38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "AI 标签", -1))
const _hoisted_2 = { class: "desc-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "鼻部", -1))
const _hoisted_4 = { class: "check-block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "皮肤", -1))
const _hoisted_6 = { class: "check-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "轮廓", -1))
const _hoisted_8 = { class: "check-block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "眼睛", -1))
const _hoisted_10 = { class: "check-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "其他", -1))
const _hoisted_12 = { class: "check-block" }
const _hoisted_13 = { class: "btn-block" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("更新标签")
const _hoisted_15 = { class: "ai-plastic" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-title" }, "AI整形", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "眼部", -1))
const _hoisted_18 = { class: "check-block" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "鼻部", -1))
const _hoisted_20 = { class: "check-block" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "唇部", -1))
const _hoisted_22 = { class: "check-block" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "check-title" }, "面部轮廓", -1))
const _hoisted_24 = { class: "check-block" }
const _hoisted_25 = { class: "btn-block" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" AI整形 ")
const _hoisted_27 = {
  class: "img-block",
  "element-loading-text": "生成模型平均时间为30-60秒，请耐心等待..."
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "add-btn" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 是否应用照片到文案中")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1677664207696",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2815",
  width: "25",
  height: "25"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M721.768049 957.138196c-7.789407 0-15.579837-2.935865-21.571295-8.867972l-419.492096-414.459476c-5.812379-5.752004-9.106402-13.601786-9.106402-21.810748 0-8.207939 3.295046-16.057721 9.106402-21.809725l419.492096-414.459476c11.983939-11.983939 31.457456-11.744485 43.382043 0.239454 11.864212 12.103666 11.744485 31.517831-0.239454 43.382043L345.955778 512l397.382543 392.648728c11.983939 11.864212 12.103666 31.277354 0.239454 43.382043C737.586316 954.082604 729.678206 957.138196 721.768049 957.138196z",
    fill: "#fff",
    "p-id": "2816"
  })
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1677664235944",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3017",
  width: "25",
  height: "25"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M743.316831 490.190275 323.823712 75.730799c-12.102642-11.983939-31.457456-11.744485-43.38102 0.239454-11.923564 12.103666-11.803837 31.517831 0.23843 43.382043l397.382543 392.648728L280.682146 904.648728c-12.043291 11.864212-12.163017 31.277354-0.23843 43.382043 5.991458 6.051833 13.900591 9.107425 21.809725 9.107425 7.789407 0 15.578814-2.935865 21.570271-8.867972l419.492096-414.459476c5.752004-5.752004 9.107425-13.601786 9.107425-21.810748C752.424256 503.792061 749.068835 495.942279 743.316831 490.190275z",
    fill: "#fff",
    "p-id": "3018"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]

import { deepClone } from "@/util/oauth";
import { onMounted, ref, watch } from "vue";
import {
  aiLabels,
  getTypeNameByTag,
  getAiPlaticResult,
  aiPlasticModel,
  aiPlasticEmitModel,
  aiPlasticLabels,
} from "@/api/ai";
import { NSelect, NForm, NFormItem } from "naive-ui";
import { ElMessage } from "element-plus";
import useClipboard from "vue-clipboard3";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  aiLabel: {
    type: Array as any,
  },
  isSpread: {
    type: Boolean,
    default: false,
  },
  userMsg: {
    type: Object,
    default: null,
    required: false,
  },
},
  emits: [
  "changeLabel",
  "changeLabelType",
  "changeAiPlastic",
],
  setup(__props, { emit: emits }) {

const props = __props


// eslint-disable-next-line no-undef


let isShowLabels = ref(false);
let checkedLabelList = ref<Array<string>>();

watch(
  () => props.aiLabel,
  (newVal: Array<string>, oldVal: Array<string>) => {
    checkedLabelList.value = deepClone(newVal);
    plasticList.value = getTypeNameByTag(checkedLabelList.value || []);
  }
);
watch(
  () => props.isSpread,
  (newVal: boolean, oldVal: boolean) => {
    isShowLabels.value = newVal;
  }
);
watch(
  () => props.userMsg,
  (newVal: any, oldVal: any) => {
    userMsg.value = newVal;
  }
);
let userMsg = ref<aiPlasticModel>({
  userId: "",
  id: "",
  project: "",
  imageUrls: [],
});
// 获取分组
let labelTextGroup = ref("ai测脸");
let labelTextGroupList = ref([
  {
    label: "AI测脸",
    value: "52",
    disabled: false,
  },
  {
    label: "小红书看脸",
    value: "53",
    disabled: false,
  },
]);
const chanegSelect = (val: string) => {
  emits("changeLabelType", val);
};

onMounted(() => {
  checkedLabelList.value = props.aiLabel;
  isShowLabels.value = props.isSpread;
  userMsg.value = props.userMsg as aiPlasticModel;
});

// 标签点击
const labelClick = (label: string) => {
  if (checkedLabelList.value == undefined) {
    checkedLabelList.value = [];
  }
  if (checkedLabelList.value.filter((x) => x == label).length > 0) {
    checkedLabelList.value = checkedLabelList.value.filter((x) => x != label);
    return false;
  }

  checkedLabelList.value.push(label);
  checkedLabelList.value = [...new Set(checkedLabelList.value)];
};
const submitLabel = () => {
  plasticList.value = getTypeNameByTag(checkedLabelList.value || []);
  emits("changeLabel", checkedLabelList.value);
};

const checkLabel = (item: string): boolean => {
  let clickedList = checkedLabelList.value?.filter((x) => x == item);
  if (clickedList == undefined) {
    return false;
  }
  return clickedList.length > 0 ? true : false;
};

let plasticList = ref<Array<string>>([]);
const plasticClick = (val: string) => {
  if (plasticList.value == undefined) {
    plasticList.value = [];
  }
  plasticList.value = [val];
  // if (plasticList.value.filter((x) => x == val).length > 0) {
  //   plasticList.value = plasticList.value.filter((x) => x != val);
  //   return false;
  // }
  // plasticList.value.push(val);
  // plasticList.value = [...new Set(plasticList.value)];
};
const checkPlastic = (val: string) => {
  return plasticList.value.filter((x) => x == val).length > 0 ? true : false;
};

// AI 整形
let plasticUrl = ref("");
let random = ref(0);
const getAiPlasticPic = async () => {
  if (plasticList.value.length == 0) {
    ElMessage.warning("请选择需要调整的部位");
    return;
  }
  userMsg.value.project = plasticList.value[0];
  const paramter = aiPlasticLabels.filter(
    (x) => x.projectName == plasticList.value[0]
  )[0].parameter;
  await getAiPlaticResult(userMsg.value, false, paramter);
  random.value += 1;
  // plasticUrl.value = `https://robot.meb.fit/ai_camera/${userMsg.value.userId}/${userMsg.value.project}/${userMsg.value.imageUrls[0]}_result_file_name.jpg`;
  plasticUrl.value = `https://robot.meb.fit/ai_camera/${userMsg.value.userId}/${userMsg.value.project}/${userMsg.value.id}_0_${userMsg.value.imageUrls[0]}.jpg`;
};
let imgLoading = ref(false);
let timer: any = null;
const pic404 = () => {
  if (plasticUrl.value == "") {
    return;
  }
  clearInterval(timer);
  imgLoading.value = true;
  timer = setInterval(() => {
    random.value += 1;
  }, 10 * 1000);
};

let isShowAddBtn = ref(false);
let isSecond = ref(false);
const picLoad = async () => {
  if (plasticList.value.length > 1 && !isSecond.value) {
    isSecond.value = true;
    const paramter = aiPlasticLabels.filter(
      (x) => x.projectName == plasticList.value[0]
    )[0].parameter;
    let param: aiPlasticModel = {
      userId: userMsg.value.userId,
      id: userMsg.value.id,
      project: plasticList.value[1],
      imageUrls: [plasticUrl.value],
    };
    await getAiPlaticResult(param, true, paramter);
    // plasticUrl.value = `https://robot.meb.fit/ai_camera/${param.userId}/${param.project}/${userMsg.value.imageUrls[0]}.jpg`;
    plasticUrl.value = `https://robot.meb.fit/ai_camera/${userMsg.value.userId}/${userMsg.value.project}/${userMsg.value.id}_0_${userMsg.value.imageUrls[0]}.jpg`;
  }
  isShowAddBtn.value = true;
  clearInterval(timer);
  imgLoading.value = false;
};
const getLoadingText = () => {
  return "生成模型平均时间为30-60秒，请耐心等待...";
};
const addAiPlasticText = () => {
  let param: aiPlasticEmitModel = {
    picUrl: plasticUrl.value,
    labelList: plasticList.value,
  };
  emits("changeAiPlastic", param);
};
const { toClipboard } = useClipboard();
const copyPic = async () => {
  try {
    await toClipboard(`<img src='${plasticUrl.value}'/>`);
    ElMessage.success("已复制图片");
  } catch (e) {
    console.log("复制失败：" + e);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_check_tag = _resolveComponent("el-check-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "label-block",
      style: _normalizeStyle(!_unref(isShowLabels) ? 'width:450px;' : 'width:0px')
    }, [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(" 已选中 " + _toDisplayString(_unref(checkedLabelList)?.length || 0) + " 个标签 ", 1),
        _createVNode(_component_el_divider),
        _createVNode(_unref(NForm), {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
          },
          "label-placement": "left",
          "label-width": "auto",
          style: {
            width: '300px',
          }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NFormItem), {
              label: "话术模板：",
              path: "选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NSelect), {
                  style: { width: '100%' },
                  value: _unref(labelTextGroup),
                  "onUpdate:value": [
                    _cache[0] || (_cache[0] = ($event: any) => (_isRef(labelTextGroup) ? (labelTextGroup).value = $event : labelTextGroup = $event)),
                    chanegSelect
                  ],
                  options: _unref(labelTextGroupList),
                  placeholder: "请选择模板"
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiLabels).nose, (item) => {
          return (_openBlock(), _createBlock(_component_el_check_tag, {
            class: "labels",
            key: item,
            checked: checkLabel(item),
            onClick: ($event: any) => (labelClick(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["checked", "onClick"]))
        }), 128))
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiLabels).skin, (item) => {
          return (_openBlock(), _createBlock(_component_el_check_tag, {
            class: "labels",
            key: item,
            checked: checkLabel(item),
            onClick: ($event: any) => (labelClick(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["checked", "onClick"]))
        }), 128))
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiLabels).outline, (item) => {
          return (_openBlock(), _createBlock(_component_el_check_tag, {
            class: "labels",
            key: item,
            checked: checkLabel(item),
            onClick: ($event: any) => (labelClick(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["checked", "onClick"]))
        }), 128))
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiLabels).eye, (item) => {
          return (_openBlock(), _createBlock(_component_el_check_tag, {
            class: "labels",
            key: item,
            checked: checkLabel(item),
            onClick: ($event: any) => (labelClick(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["checked", "onClick"]))
        }), 128))
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiLabels).others, (item) => {
          return (_openBlock(), _createBlock(_component_el_check_tag, {
            class: "labels",
            key: item,
            checked: checkLabel(item),
            onClick: ($event: any) => (labelClick(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["checked", "onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_button, {
          type: "success",
          size: "mini",
          onClick: submitLabel
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", null, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiPlasticLabels).filter((x) => x.type == '眼部'), (item) => {
              return (_openBlock(), _createBlock(_component_el_check_tag, {
                key: item.projectName,
                onClick: ($event: any) => (plasticClick(item.projectName)),
                checked: checkPlastic(item.projectName),
                class: "labels"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.projectName), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "checked"]))
            }), 128))
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiPlasticLabels).filter((x) => x.type == '鼻部'), (item) => {
              return (_openBlock(), _createBlock(_component_el_check_tag, {
                key: item.projectName,
                onClick: ($event: any) => (plasticClick(item.projectName)),
                checked: checkPlastic(item.projectName),
                class: "labels"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.projectName), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "checked"]))
            }), 128))
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiPlasticLabels).filter((x) => x.type == '唇部'), (item) => {
              return (_openBlock(), _createBlock(_component_el_check_tag, {
                key: item.projectName,
                onClick: ($event: any) => (plasticClick(item.projectName)),
                checked: checkPlastic(item.projectName),
                class: "labels"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.projectName), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "checked"]))
            }), 128))
          ]),
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiPlasticLabels).filter(
                (x) => x.type == '面部轮廓'
              ), (item) => {
              return (_openBlock(), _createBlock(_component_el_check_tag, {
                key: item.projectName,
                onClick: ($event: any) => (plasticClick(item.projectName)),
                checked: checkPlastic(item.projectName),
                class: "labels"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.projectName), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "checked"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_button, {
            type: "success",
            size: "mini",
            onClick: getAiPlasticPic,
            loading: _unref(imgLoading)
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_27, [
          (_openBlock(), _createElementBlock("img", {
            onClick: copyPic,
            src: _unref(plasticUrl),
            class: "plastic-pic",
            onerror: pic404,
            onLoad: picLoad,
            key: _unref(random)
          }, null, 40, _hoisted_28))
        ], 512), [
          [_directive_loading, _unref(imgLoading)]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_el_button, {
            style: {"margin-left":"5px"},
            type: "warning",
            size: "mini",
            onClick: addAiPlasticText
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _unref(isShowAddBtn) && !_unref(imgLoading)]
        ])
      ])
    ], 4),
    _createElementVNode("div", {
      class: "arrows-block",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(isShowLabels) //@ts-ignore
 ? isShowLabels.value = !_unref(isShowLabels) : isShowLabels = !_unref(isShowLabels))),
      style: _normalizeStyle(!_unref(isShowLabels) ? 'left:451px;' : 'left:0px;')
    }, [
      (!_unref(isShowLabels))
        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34))
        : (_openBlock(), _createElementBlock("span", _hoisted_35, _hoisted_37))
    ], 4)
  ]))
}
}

})